export default "__VITE_ASSET__rFLw0929__"